s
<template>
  <div class="container-fluid">
    <Card back>
      <template slot="header">
        <h4>صندوق دریافت ایمیل</h4>
        <hr />
      </template>
      <template slot="content">
        <div class="row">
          <div class="col-8">
            <small id="LblGetEmail">انتخاب ایمیل</small>
            <SearchableCombo :edit="false" :grp="$session.get('UserInfo').tblUserId" :code="null" @ResultCombo="GetEmail" :action="'TblCrmCombo/GetEmailByUser'" :method="'POST'" :idinput="'GetEmail'" :keyItem="'GetEmail'" :disabled="false" :ClassProps="'required'"> </SearchableCombo>
            <button class="btn btn-primary w-100" @click="call">تماس</button>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <BnpGrid :action="true" :propsRows="EmailList" :propsColumn="propsColumn" :NoRowNum="true" v-if="$store.state.renderComponentGrid">
              <template slot="action-slot" slot-scope="props">
                <a class="badge badge-secondary" @click="OpenMail(props.props)">مشاهده</a>
              </template>
            </BnpGrid>
          </div>
          <modal v-if="$store.state.Modal" :InheritanceTheme="true" :IsFooter="false" :Size="'Md'">
            <template v-slot:header>
              <h5 class="mx-2">{{ ModalEmail['subject'] }}</h5>
            </template>
            <template v-slot:body>
              <div class="col-12">
                <p v-html="ModalEmail['body']" id="mailbody"></p>
              </div>
              <hr />
              <div class="col-12">
                <a v-for="(item, i) in ModalEmail.download" :key="i" target="_blank" :download="item.name" :href="$cookies.get('URL') + item.address" class="badge badge-secondary">{{ item.name }}&nbsp; <i class="fas fa-download"></i></a>
              </div>
            </template>
          </modal>
        </div>
      </template>
    </Card>
  </div>
</template>
<script>
import Card from '@/components/Card/Card.vue'
import SearchableCombo from '@/components/Combo/SearchableCombo.vue'
import BnpGrid from '@/components/BnpGrid/BnpGrid.vue'
import Modal from '../../Modal/Modal.vue'

export default {
  data() {
    return {
      ModalEmail: null,
      EmailList: [],
      propsColumn: [
        { name: 'from', label: 'فرستنده', visibility: true },
        { name: 'subject', label: 'موضوع ', visibility: true },
        { name: 'date', label: ' تاریخ', visibility: true },
      ],
    }
  },

  components: { Card, SearchableCombo, BnpGrid, Modal },
  methods: {
    call() {
      // var axios = { Method: 'POST', Action: 'http://192.168.1.125/ClickToCall.php?Mobile=09103981567&extention=17"', ArryfildValue: null }
      // this.$PostData(axios).then((result) => console.log(result))

      var axios = require('axios')
      var config = {
        method: 'POST',
        url: 'http://192.168.2.200/ClickToCall.php?Mobile=09103981567&extention=17"',
        headers: {},
        data: null,
      }
      axios(config).then((response) => response.data)
    },
    GetEmail(data) {
      if (data.id == null) {
        return
      }
      this.$mySweetDefaultTost('درحال دریافت ایمیلها', '', 'info')
      var axios = { Method: 'POST', Action: 'Inbox', ArryfildValue: { Id: data.id, Usergrp: this.$session.get('UserInfo').tblUserGrpId } }
      this.$PostData(axios).then((result) => {
        if (result.status == 'success') {
          this.$mySweetDefaultTost('دریافت موفق', '', 'success', 1500)
          result.data.forEach((element) => {
            if (element.fileAddress != null) {
              element.fileNames = element.fileNames.split('&&')
              element.fileAddress = element.fileAddress.split('&&')
              var download = []
              for (let i = 0; i < element.fileAddress.length; i++) {
                download[i] = { address: element.fileAddress[i], name: element.fileNames[i] }
              }
              element['download'] = download
            } else {
              element['download'] = []
            }
            this.EmailList.push(element)
          })
          this.$store.state.renderComponentGrid = false
          this.$nextTick(() => {
            this.$store.state.renderComponentGrid = true
          })
        } else {
          this.$mySweetDefaultTost('خطا ', result.msg, 'warning', 2000)
        }
      })
    },
    OpenMail(mail) {
      this.ModalEmail = mail
      this.$store.state.Modal = true
    },
  },
}
</script>
